<template>
  <reusable-windows ref="reusable" :isAlert="true">
    <div>
      <h2 class="mt-0 text-center">{{ title }}</h2>
      <div v-html="message"></div>
      <div style="flex-direction: row; justify-content: space-between; text-align: center">
        <span style="color: var(--Persian-Red); text-decoration: underline; line-height: 2.5rem; cursor: pointer; font-size: 18px; font-weight: 500" @click="_confirm">{{ okButton }}</span>
      </div>
    </div>
  </reusable-windows>
</template>

<script>
import reusableWindows from './ReusableWindow.vue';

export default {
  name: 'Alerta',
  components: { reusableWindows },
  data: () => ({
    title: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {
    show(options = {}) {
      this.title = options.title;
      this.message = options.message;
      this.okButton = options.okButton;
      if (options.cancelButton) {
        this.cancelButton = options.cancelButton;
      }
      this.$refs.reusable.open();
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    _confirm() {
      this.$refs.reusable.close();
      this.resolvePromise(true);
    },
    _cancel() {
      this.$refs.reusable.close();
      this.resolvePromise(false);
      //this.rejectPromise(new Error('Se canceló la acción.'))
    },
  },
};
</script>
